exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goods_info .info[data-v-613b537b]{margin-left:10px}.goods_info .info p[data-v-613b537b]{color:#666666}.goods_info .info p[data-v-613b537b]:first-child{color:#999999}.activity[data-v-613b537b]{line-height:24px}.activity span[data-v-613b537b]{width:20px;height:20px;margin-left:10px}.child_page[data-v-613b537b]{padding:30px}.common_form_search[data-v-613b537b]{padding-top:15px;padding-left:15px;padding-right:15px;background-color:#ffffff;border-bottom:1px solid #eeeeee}\n", ""]);

// exports
